import { PrintMenu } from '../print-menu';
import { Type } from '@angular/core';
import { MenuSectionHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section-header/menu-section-header.component';
import { SpaceMonkeyPrintHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section-header/space-monkey-print-header/space-monkey-print-header.component';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { BandedRowMode } from '../../enum/shared/banded-row-mode.enum';
import { ProductMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/product-menu-footer.component';
import { PrintFooterLayoutType } from '../../enum/shared/print-footer-layout-type.enum';
import { StringUtils } from '../../../utils/string-utils';
import { PrintHeaderLayoutType } from '../../enum/shared/print-header-layout-type.enum';
import { BadgeLegendFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/badge-legend-footer/badge-legend-footer.component';
import { SectionLayoutType } from '../../enum/dto/section-layout-type.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from 'src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { exists } from '../../../functions/exists';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class SpaceMonkeyPrintMenu extends PrintMenu {
  getThemeClass(): string {
    return 'space-monkey-print-theme';
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Roboto.SemiBold_600, FONT.Roboto.Medium_500, FONT.Roboto.Bold_700, FONT.Rubik.Medium_500];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/kxt2pco.css';
  }

  getPageBottomMargin(): string {
    return '0.25in';
  }

  getPageTopMargin(): string {
    return '0.25in';
  }

  getPageLeftMargin(): string {
    return '0.25in';
  }

  getPageRightMargin(): string {
    return '0.25in';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getPrintHeaderLayoutType(): PrintHeaderLayoutType {
    return this.menuOptions?.printHeaderLayout || PrintHeaderLayoutType.FirstPage;
  }

  getSectionsHeaderType(): Type<MenuSectionHeaderComponent> {
    return SpaceMonkeyPrintHeaderComponent;
  }

  getFooterType(): Type<ProductMenuFooterComponent> {
    return BadgeLegendFooterComponent;
  }

  getPrintFooterLayoutType(): PrintFooterLayoutType {
    return this.menuOptions?.printFooterLayout || PrintFooterLayoutType.AllPagesFixed;
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.Brand, 0],
      [SectionColumnProductInfoType.ProductTitle, 1],
      [SectionColumnProductInfoType.Label, 2],
      [SectionColumnProductInfoType.Strain, 3],
      [SectionColumnProductInfoType.StrainType, 4],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(5),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(6),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(7),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(8),
      [SectionColumnProductInfoType.QuantityAndSize, 9],
      [SectionColumnProductInfoType.Size, 10],
      [SectionColumnProductInfoType.Quantity, 11],
      [SectionColumnProductInfoType.VariantType, 12],
      [SectionColumnProductInfoType.Stock, 13],
      [SectionColumnProductInfoType.GradingResults, 14],
      [SectionColumnProductInfoType.VariantPrice, 15],
      [SectionColumnProductInfoType.Badge, 16]
    ]);
  }

  bandedRowMode(): BandedRowMode {
    return BandedRowMode.Even;
  }

  bandedRowsDefaultEnabled(): boolean {
    return true;
  }

  bandedRowColor(rowViewModel: SectionRowViewModel, odd: boolean): string {
    const rowIsBanded = this.currentRowIsBanded(odd);
    const bgColor = rowViewModel?.section?.metadata?.productsContainerBackgroundColor;
    if (exists(bgColor) && rowIsBanded) {
      return '#FFFFFF';
    } else if (!bgColor && rowIsBanded) {
      // In order for the contrast of row/column colors to mix, we must have opacity (cant use pure hex)
      return 'rgba(91,146,233,0.15)';
    } else {
      return null;
    }
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getPriceColumnTitle(col: SectionColumnViewModel): string {
    const title = super.getPriceColumnTitle(col);
    return col.sectionLayoutType !== SectionLayoutType.List ? StringUtils.removeWhiteSpace(title) : title;
  }

  getTitleSectionBottomMargin(): string {
    return '1.091rem';
  }
}
